import { Chart } from 'angular-highcharts';

export class ChartDefinition {
	lineChart: Chart;
	columnChart: Chart;

	public getLineTemplate (chartTitle: string = '', xAxisTitle: string = '', yAxisTitle:string = '',  months: string[], showFormat = false): Chart {
		this.lineChart  = new Chart({
			chart: {
				type: 'line'
			  },
			credits: {
				enabled: false
			  },
			title: {
				text: chartTitle
			  },
			xAxis: {
					  categories: months,
					  title: {
				  text: xAxisTitle
				}
			  },
			yAxis: {
				min: 0,
				labels : showFormat ? { format: '{value}%'} : {format: '{value}'},
				title: {
				  text: yAxisTitle
				}
			  },
			legend: {
				layout: 'vertical',
				align: 'right',
				verticalAlign: 'middle'
				},
			plotOptions: {
				series: {
					stacking: undefined
				}
				},
			series: []
		});

		return this.lineChart;
	}
	public getColumnTemplate (chartTitle = '', xAxisTitle = '', yAxisTitle = '',  months: string[], showFormat = false, legendTitle: string = ''): Chart {
		this.columnChart  = new Chart({
			chart: {
        type: 'column'
        },
			credits: {
				enabled: false
			  },
			title: {
				text: chartTitle
        },
			xAxis: {
					  categories: months,
					  title: {
				  text: xAxisTitle
				}
			  },
			yAxis: {
				labels : showFormat ? { format: '{value}%'} : {format: '{value}'},
				title: {
				  text: yAxisTitle
				}
			  },
			legend: {
				layout: 'vertical',
				align: 'right',
        verticalAlign: 'middle',
        title: {
            text: legendTitle
          },
        padding: 20
				},

			plotOptions: {
						column: {
					pointPadding: 0.2,
					borderWidth: 0
				}
			}
		});

		return this.columnChart;
	}

	public getPercentageTemplate (chartTitle = '', xAxisTitle = '', yAxisTitle = '',  months: string[], showFormat = false): Chart {
		this.columnChart  = new Chart({
			chart: {
				type: 'column'
			  },
			credits: {
				enabled: false
			  },
			title: {
				text: chartTitle
        },
        tooltip: {
          formatter: function () {
              return this.series.name + ' : ' + this.y + '%';
          }
      },
			xAxis: {
        categories: months,    
        title: {
          text: xAxisTitle
        }
      },
			yAxis: {
				labels : showFormat ? { format: '{value}%'} : {format: '{value}'},
        plotLines: [{
          color: '#000000',
          width: 2,
          value: 0,
          
        }],        
				title: {
				  text: yAxisTitle
				}
			  },
			legend: {
				layout: 'vertical',
				align: 'right',
				verticalAlign: 'middle'
				},

			plotOptions: {
						column: {
					pointPadding: 0.2,
					borderWidth: 0
        }
			}
		});

		return this.columnChart;
	}



}


